module.exports = __webpack_public_path__ + "img/private-napolimania-fish-1.29d737a2.jpg";